import React from 'react';

import Usuario from '../index';

const Medico: React.FC = () => {
  return <Usuario Tipo="Usuario" />;
};

export default Medico;
